const map = {
	"./AuthorPage/index.js": 4480,
	"./BlogHighlights/index.js": 65109,
	"./BlogPage/index.js": 43595,
	"./BlogsGrid/index.js": 22505,
	"./BlueprintJackpots/index.js": 11308,
	"./Content/index.js": 37461,
	"./DoubleJackpots/index.js": 9622,
	"./EmailTemplatePage/index.js": 35817,
	"./Footer/index.js": 48239,
	"./GameCarousel/index.js": 74804,
	"./GameTile/index.js": 17570,
	"./GamesRow/index.js": 31409,
	"./GamesRowExpandable/index.js": 79221,
	"./HeadlessJackpots/index.js": 69404,
	"./LandingOrPostPage/index.js": 99947,
	"./LotteryResults/index.js": 11337,
	"./NotFound/index.js": 55423,
	"./PreRegistrationForm/index.js": 56742,
	"./PromoTilesRow/index.js": 36804,
	"./Tickers/index.js": 90875,
	"./UKGC/index.js": 20002,
	"./UnicornNavigationMenu/index.js": 73157,
	"./WelcomeOffer/index.js": 8966,
	"./WinnersContainer/index.js": 91647
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		const e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 27182;
module.exports = webpackContext;